import { GetStaticProps } from 'next';
import { GetStaticPropsContext } from 'next/types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ENavTransparency } from '@features/navigation/typescript';
import { IInstructionSection } from '@features/instructions/sections/GroupList/typescript';
import GroupSection from '@features/instructions/sections/GroupList/GroupSection';
import { getLayoutData } from '@features/layout/api';
import { ISeo, TLocale, WindowType } from '@typescript/index';
import MainSeo from '@components/MainSeo/MainSeo';
import { REVALIDATION_TIME } from '@config/index';
import SelfCanonicalLink from '@features/seo/SelfCanonicalLink/SelfCanonicalLink';
import { getDevProps } from '@components/DevToolbar/helpers/getDevProps';
export type PropsType = {
  seo: ISeo;
  fileList: IInstructionSection;
  windowType: WindowType;
  isBuildTime?: boolean;
};
const instructions = ({
  seo,
  windowType,
  isBuildTime
}: PropsType) => {
  if (isBuildTime) {
    return <div>Build time</div>;
  }
  return <>
      <SelfCanonicalLink />
      <main id="main-content">
        {seo && <MainSeo seo={seo} />}
        <GroupSection windowType={windowType} />
      </main>
    </>;
};
export const getStaticProps: GetStaticProps = async ({
  locale
}: GetStaticPropsContext) => {
  if (process.env.IS_BUILD) {
    return {
      props: {
        isBuildTime: true
      },
      revalidate: 1
    };
  }
  return {
    props: {
      ...getDevProps('static', REVALIDATION_TIME),
      isBuildTime: false,
      ...(await getLayoutData(locale as TLocale)),
      ...(await serverSideTranslations(locale as string)),
      navParams: {
        navTransparency: ENavTransparency.BOTH_NOT_TRANSPARENT
      }
    },
    revalidate: REVALIDATION_TIME
  };
};
export default instructions;